import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

// ----------------------------------------------------------------------

type Props = {
  height?: number;
  emptyRows: number;
  show: boolean;
};

export default function TableEmptyRows({ emptyRows, height, show }: Props) {
  if (!emptyRows || !show) {
    return null;
  }

  return (
    <TableRow
      sx={{
        ...(height && {
          height: height * emptyRows,
        }),
      }}
    >
      <TableCell colSpan={9} />
    </TableRow>
  );
}
